import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import FormSingleSelect, { SelectItem } from 'src/components/Control/FormControls/FormSingleSelect';
import { ErrorBag } from 'src/models/ErrorModel';
import { FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FORM_ID } from 'src/models/FormModel';
import { ProductType } from 'src/constants/Products';

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: '480px',
    marginTop: 0,
    marginBottom: '8px',
  },
}));

interface Props {
  disabled?: boolean,
  form: FORM_ID,
  id?: string,
  name: string,
  onChange: (value:ProductType, field: string) => void,
  value?: string,
}

const ProductTypeSelector = (props: Props) => {
  const classes = useStyles();

  const {
    disabled, form, id, name, onChange, value,
  } = props;

  const types = [
    ProductType.donation,
    ProductType.fee,
    ProductType.product,
    ProductType.ticket,
  ];

  const errors: ErrorBag =
    useSelector((state:Store) => state.errors[form] || {} as ErrorBag);

  const getItems = () => {
    const items:SelectItem[] = [];
    types.map((item: any) => {
      items.push({
        id: item,
        text: item,
      } as SelectItem);
      return items;
    });
    return items;
  };

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      error={!!errors[name]}
      key={`form-control-${name}`}>
      <FormSingleSelect
        disabled={disabled}
        form={form}
        id={id}
        items={getItems()}
        label="Type"
        name={name}
        onChange={onChange}
        value={value || ''}
        noMarginTop />
    </FormControl>
  );
};

export default ProductTypeSelector;
